import { render, staticRenderFns } from "./hot-flow.vue?vue&type=template&id=faf5d6ac&scoped=true"
import script from "./hot-flow.vue?vue&type=script&lang=js"
export * from "./hot-flow.vue?vue&type=script&lang=js"
import style0 from "./hot-flow.vue?vue&type=style&index=0&id=faf5d6ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf5d6ac",
  null
  
)

export default component.exports